import { Lock } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

// Lote 159 — "Particular": o que eu marco aqui o escritório não enxerga (nada muda de conta; só deixa de aparecer para os colegas).

export function BadgeParticular({ testid, className = "" }) {
  return (
    <span
      data-testid={testid}
      title="Particular — só você vê este item. O escritório não enxerga."
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border border-stone-300 bg-stone-100 text-[10px] font-bold uppercase tracking-wide text-stone-600 align-middle ${className}`}
    >
      <Lock className="w-3 h-3" strokeWidth={2} aria-hidden="true" /> Particular
    </span>
  );
}

// tipo: "processo" | "evento"; ids: array; value: true (esconder do escritório) | false (voltar a compartilhar).
// Devolve a resposta do servidor ({alterados, ignorados}) ou null se falhou. Avisa na tela o que aconteceu.
export async function marcarParticular(tipo, ids, value) {
  try {
    const { data } = await http.post("/particular", { tipo, ids, value });
    const n = data.alterados || 0;
    const um = n === 1;
    const nome = tipo === "processo" ? (um ? "processo" : "processos") : (um ? "evento" : "eventos");
    if (n > 0) {
      toast.success(
        value ? `${n} ${nome} ${um ? "agora é particular" : "agora são particulares"}` : `${n} ${nome} ${um ? "voltou a ser compartilhado" : "voltaram a ser compartilhados"}`,
        { description: value ? "O escritório não vê mais — só você." : "O escritório volta a enxergar." },
      );
    }
    const ign = data.ignorados || [];
    if (ign.length) {
      const motivo = ign.find((i) => i.motivo?.startsWith("outra pessoa"));
      toast.warning(`${ign.length} ${ign.length === 1 ? "item não pôde" : "itens não puderam"} ser marcado${ign.length === 1 ? "" : "s"}`, {
        description: motivo ? "Quando outra pessoa é a responsável, o processo precisa continuar visível a ela." : "Itens não encontrados ou que não são da sua conta.",
      });
    }
    return data;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Não consegui alterar. Tente de novo.");
    return null;
  }
}

// Lote 160 — evento que veio de um parceiro (somente leitura, lido da conta de origem a cada abertura).
export function BadgeCompartilhado({ de, testid, className = "" }) {
  return (
    <span data-testid={testid} title={`Compartilhado com você${de ? ` por ${de}` : ""} — somente consulta`}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border border-sky-200 bg-sky-50 text-[10px] font-bold uppercase tracking-wide text-sky-800 align-middle ${className}`}>
      Compartilhado{de ? ` · ${de}` : ""}
    </span>
  );
}
